//* Libraries imports
import { useQuery } from "@tanstack/react-query";

//* Schemas Import
import { fullProcess } from "../../../schemas/common/process/process";

//* Axios Import
import { privateApi } from "../../../services/apis/configs/apiClient";

//* Zod Import
import { z } from "zod";


const processDetailResponseSchema = z.object({
  processo: fullProcess,
});

/**
 * API para processos
 */
const ProcessAPI = {
  /**
   * Obtém um processo específico pelo seu ID
   * @param id ID do processo a ser recuperado
   * @returns Detalhes completos do processo ou erro
   */
  getById: async function (id: number) {
    try {      
      
      const response = await privateApi.get(
        `/student_portal/private/processos/get_processo/${id}`
      );
      

      const validatedResponse = processDetailResponseSchema.parse(response.data);
      

      return {
        data: validatedResponse.processo,
        success: true
      };
    } catch (error) {
      console.error(`Erro ao buscar processo com ID ${id}:`, error);
      return {
        data: null,
        success: false,
        message: "Não foi possível carregar os detalhes do processo. Tente novamente mais tarde."
      };
    }
  }
}



/**
 * Hook para obter um processo específico pelo ID
 * @param id ID do processo a ser recuperado
 * @returns Query para detalhes completos do processo
 */
export function useGetProcessById(id: number) {
  return useQuery({
    queryKey: ["process", id],
    queryFn: async () => await ProcessAPI.getById(id),
    retry: 2,
    staleTime: 1000 * 60 * 5,
    enabled: !!id, 
  });
}
